var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailBrand = function SvgMailBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.28 18.075H3.72a.596.596 0 0 1-.595-.596V6.663l5.959 5.198-3.426 3.213a.5.5 0 1 0 .684.73l3.5-3.283 1.004.877c.323.282.739.423 1.154.423.415 0 .83-.141 1.154-.423l1.006-.877 3.498 3.282a.499.499 0 0 0 .707-.023.5.5 0 0 0-.023-.706l-3.425-3.213 5.958-5.196v10.814a.596.596 0 0 1-.595.596Zm-7.783-5.431c-.264.231-.73.23-.994 0L3.8 5.925h16.402l-7.705 6.719Zm7.783-7.719H3.72c-.88 0-1.595.716-1.595 1.596v10.958c0 .88.716 1.596 1.595 1.596h16.56c.88 0 1.595-.716 1.595-1.596V6.521c0-.88-.715-1.596-1.595-1.596Z",
    fill: "currentColor"
  })));
};
export default SvgMailBrand;